const EMAIL_REGEX = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
const PHONE_REGEX = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/

export class Validator {
  constructor() {
    this.rules = {}
  }

  required() {
    this.rules.required = true
    return this
  }

  email() {
    this.rules.email = true
    return this
  }

  phoneNumber() {
    this.rules.phoneNumber = true
    return this
  }

  validate(value) {
    if (this.rules.required && (value === null || value === undefined || value === '')) {
      return 'This field is required'
    }

    if (this.rules.email && !value.match(EMAIL_REGEX)) {
      return 'Invalid email. Please try again.'
    }

    if (this.rules.phoneNumber && !value.match(PHONE_REGEX)) {
      return 'Invalid phone number. Please try again.'
    }

    return false
  }
}
